export default <MeStore>{
  id: '',
  sub: '',
  lastName: '',
  firstName: '',
  lastKana: '',
  firstKana: '',
  prefecture: 0,
  email: '',
  authLevel: 0,
  phoneNumber: '',
  teamId: 0,
  customerId: '',
  isOptioned: false,
  intensity: 0,
  plan: 1,
  position: '',
  organization: '',
  gender: null,
  birthdate: '',
  provider: '',
  isForceCanceled: false,
};
